<template>
  <div class="invite-code-input-section">
    <img
      class="invite-code-input-section__icon"
      src="@/assets/home/icn_invite_heart.png"
    />
    <div class="invite-code-input-section__text">
      <span class="typo-heading-xl-bold">친구의 초대코드를 입력해 주세요.</span>
      <span class="typo-body-s-medium">친구에게 전달받은 코드를 입력하고 함께 혜택을 받아보세요!</span>
    </div>
    <div class="invite-code-input-section__form">
      <InviteCodeInput
        :value="inputCode"
        :hasError="hasError"
        :message="errorMessage"
        :disabled="isAlreadyReferred || notEligible"
        :notEligible="notEligible"
        :rewardStatus="rewardStatus"
        @input="onInput"
      />
      <div
        class="invite-code-input-section__btn"
        :class="{ 'invite-code-input-section__btn--disabled': isAlreadyReferred || notEligible }"
        @click="onSubmit"
      >
        <span class="typo-btn-m-medium" style="color: var(--color-white, #FFF);">확인</span>
      </div>
    </div>
  </div>
</template>

<script>
import InviteCodeInput from '@/components/new/atoms/InviteCodeInput.vue'

export default {
  name: 'InviteCodeInputSection',
  components: {
    InviteCodeInput,
  },
  props: {
    inputCode: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    isAlreadyReferred: {
      type: Boolean,
      default: false,
    },
    notEligible: {
      type: Boolean,
      default: false,
    },
    rewardStatus: {
      type: String,
      default: '',
    },
  },
  methods: {
    onInput(val) {
      this.$emit('input', val)
    },
    onSubmit() {
      if (this.isAlreadyReferred || this.notEligible) return
      this.$emit('submit')
    },
  },
}
</script>

<style scoped>
.invite-code-input-section {
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
}

.invite-code-input-section__icon {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.invite-code-input-section__text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.invite-code-input-section__form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-self: stretch;
}

.invite-code-input-section__btn {
  display: flex;
  height: 48px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 12px;
  background: var(--color-form-focus-stroke, #008DEF);
  cursor: pointer;
}

.invite-code-input-section__btn--disabled {
  background: var(--color-bg-disabled, #D1D6DB);
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/InviteCodeInputSection.vue